
import { useApiStore } from "@/stores/apiStore";
import { useAuthStore } from "@/stores/authStore";
import { AxiosError } from "axios";
import { defineComponent } from "vue";

export default defineComponent({
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		return {
			api,
			authStore
		};
	},
	name: "imdex-activate-account",
	data: () => {
		return {
			// eslint-disable-next-line

			email: "",
			isLoading: true,
			errorMessage: "",
			success: false,
			successMessage: ""
		};
	},
	async mounted() {
		this.isLoading = true;
		if (this.$route.query.token != null && this.$route.query.userId != null) {
			try {
				await this.api.get(
					`/activate-account?token=${this.$route.query.token}&userId=${this.$route.query.userId}`
				);
				this.isLoading = false;
				this.success = true;
				this.successMessage = this.$t("activateAccount.successMessage");
				// await this.api.get(`/user/read/me?auth0=true`)
				// setTimeout(()=>{
				//     this.$router.push('/ssa')
				// },5000)
			} catch (e) {
				if (e instanceof AxiosError) {
					this.errorMessage = e.response?.data.message;
					this.isLoading = false;
				}
			}
		} else {
			this.isLoading = false;
		}
	},
	methods: {
		async logoutAndBack() {
			this.authStore.logout();
		}
	}
});
